var map = {
	"./DevAllot.vue": "a5ce",
	"./DevAllotArch.vue": "bd3e",
	"./DevBasic.vue": "90c1",
	"./DevCheck.vue": "9013",
	"./DevInfo.vue": "078c",
	"./DevPurchArch.vue": "22a8",
	"./DevPurchArch_bak.vue": "5f90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e65f";